import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-72bf8d70"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "claimAirDrop"
}
const _hoisted_2 = { class: "claimAirDrop__total" }
const _hoisted_3 = { class: "claimAirDrop__container" }
const _hoisted_4 = { class: "claimAirDrop__header claimAirDrop__mainTxt" }
const _hoisted_5 = { class: "claimAirDrop__summaryData claimAirDrop__basicText" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "vl" }, null, -1 /* HOISTED */))
const _hoisted_7 = { class: "claimAirDrop__container" }
const _hoisted_8 = { class: "claimAirDrop__header" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "claimAirDrop__hr" }, null, -1 /* HOISTED */))
const _hoisted_10 = { class: "claimAirDrop__progressHeader" }
const _hoisted_11 = {
  key: 0,
  style: {"margin":"0 0 20px 10px"}
}
const _hoisted_12 = {
  key: 1,
  style: {"margin":"0 0 20px 10px"}
}
const _hoisted_13 = { class: "claimAirDrop__data" }
const _hoisted_14 = { class: "claimAirDrop__data-text" }
const _hoisted_15 = { class: "claimAirDrop__data-text" }
const _hoisted_16 = {
  key: 0,
  class: "claimAirDrop__data-text"
}
const _hoisted_17 = { class: "claimAirDrop__data-text" }
const _hoisted_18 = { class: "claimAirDrop__body" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = {
  key: 1,
  class: "claimAirDrop__missions"
}
const _hoisted_21 = { class: "claimAirDrop__leftCol" }
const _hoisted_22 = { class: "claimAirDrop__smallTxt" }
const _hoisted_23 = {
  key: 2,
  class: "claimAirDrop"
}
const _hoisted_24 = { class: "claimAirDrop__total" }
const _hoisted_25 = { class: "claimAirDrop__container" }
const _hoisted_26 = { class: "claimAirDrop__header claimAirDrop__mainTxt" }
const _hoisted_27 = { class: "sharePopup" }
const _hoisted_28 = ["href"]
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "32",
    height: "24",
    "xmlns:svg": "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1668.56 1221.19",
    "xml:space": "preserve"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M283.94,167.31l386.39,516.64L281.5,1104h87.51l340.42-367.76L984.48,1104h297.8L874.15,558.3l361.92-390.99h-87.51l-313.51,338.7l-253.31-338.7H283.94z M412.63,231.77h136.81l604.13,807.76h-136.81L412.63,231.77z",
      fill: "white"
    })
  ]),
  /*#__PURE__*/_createTextVNode(" Tweet ")
], -1 /* HOISTED */))
const _hoisted_30 = [
  _hoisted_29
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($setup.loginPopupStatus)
      ? (_openBlock(), _createBlock($setup["LoginPopUp"], {
          key: 0,
          showAddressOption: false,
          onClose: _cache[0] || (_cache[0] = ($event: any) => ($setup.loginPopupStatus =! $setup.loginPopupStatus))
        }))
      : _createCommentVNode("v-if", true),
    ($setup.useUserStore().isLoggedIn && $setup.useUserStore().getAccount.address)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          ($setup.claimingProcessStarted)
            ? (_openBlock(), _createBlock($setup["ClaimingOptionsPopup"], {
                key: 0,
                onClose: _cache[1] || (_cache[1] = ($event: any) => ($setup.claimingProcessStarted = false)),
                onClaim: $setup.claim
              }))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h4", _hoisted_4, _toDisplayString(_ctx.$t('AIRDROP.TOTAL_HEADER')), 1 /* TEXT */),
              _createElementVNode("div", _hoisted_5, [
                _createVNode($setup["ClaimInfo"], {
                  header: _ctx.$t('AIRDROP.TOTAL'),
                  class: "claimAirDrop__boldText claimAirDrop__summaryTile"
                }, {
                  default: _withCtx(() => [
                    _createVNode($setup["CoinAmount"], {
                      amount: $setup.useAirDropStore().getSummary.totalAmount,
                      "show-denom": true,
                      "show-tooltip": true,
                      precision: 2
                    }, null, 8 /* PROPS */, ["amount"])
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["header"]),
                _createVNode($setup["ClaimInfo"], {
                  header: _ctx.$t('AIRDROP.TOTAL_CLAIMED'),
                  class: "claimAirDrop__boldText claimAirDrop__summaryTile",
                  "percentage-vale": $setup.useAirDropStore().getSummary.claimedPercent
                }, {
                  default: _withCtx(() => [
                    _createVNode($setup["CoinAmount"], {
                      amount: $setup.useAirDropStore().getSummary.totalClaimed,
                      "show-denom": true,
                      "show-tooltip": true,
                      precision: 2
                    }, null, 8 /* PROPS */, ["amount"])
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["header", "percentage-vale"]),
                _hoisted_6,
                _createVNode($setup["ClaimInfo"], {
                  header: _ctx.$t('AIRDROP.ACTIVE'),
                  class: "claimAirDrop__boldText claimAirDrop__summaryTile"
                }, {
                  default: _withCtx(() => [
                    _createVNode($setup["CoinAmount"], {
                      amount: $setup.useAirDropStore().getSummary.activeCampaigns,
                      "show-denom": true,
                      "show-tooltip": true,
                      precision: 2
                    }, null, 8 /* PROPS */, ["amount"])
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["header"]),
                _createVNode($setup["ClaimInfo"], {
                  header: _ctx.$t('AIRDROP.TO_CLAIM'),
                  class: "claimAirDrop__boldText claimAirDrop__summaryTile",
                  "percentage-vale": $setup.useAirDropStore().getSummary.toClaimPercent
                }, {
                  default: _withCtx(() => [
                    _createVNode($setup["CoinAmount"], {
                      amount: $setup.useAirDropStore().getSummary.toClaim,
                      "show-denom": true,
                      "show-tooltip": true,
                      precision: 2
                    }, null, 8 /* PROPS */, ["amount"])
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["header", "percentage-vale"])
              ])
            ])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.airDropStore.getCampaigns, (campaign, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "claimAirDrop__total claimAirDrop__basicText",
              key: index
            }, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("h4", _hoisted_8, _toDisplayString(campaign.name), 1 /* TEXT */),
                _hoisted_9,
                _createElementVNode("div", _hoisted_10, [
                  ($setup.checkCampaignStatus(campaign.start_time, campaign.end_time) !== $setup.CampainStatus.Past)
                    ? (_openBlock(), _createElementBlock("h5", _hoisted_11, _toDisplayString(_ctx.$t('CLAIM_AIRDROP.PROGRESS')), 1 /* TEXT */))
                    : (_openBlock(), _createElementBlock("h5", _hoisted_12, _toDisplayString(_ctx.$t('CLAIM_AIRDROP.FINISHED')), 1 /* TEXT */))
                ]),
                ($setup.checkCampaignStatus(campaign.start_time, campaign.end_time) !== $setup.CampainStatus.Past)
                  ? (_openBlock(), _createBlock($setup["PercentageBar"], {
                      key: $setup.updateComponent,
                      amount: $setup.calculateProgress(campaign.start_time, campaign.end_time),
                      status: $setup.checkCampaignStatus(campaign.start_time, campaign.end_time),
                      "time-to-pass": $setup.calculateTimeToPass(campaign)
                    }, null, 8 /* PROPS */, ["amount", "status", "time-to-pass"]))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("div", _hoisted_13, [
                  _createVNode($setup["ClaimInfo"], {
                    header: _ctx.$t('AIRDROP.CLAIMED')
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_14, [
                        _createVNode($setup["CoinAmount"], {
                          amount: $setup.calculateMissions(campaign),
                          "show-denom": true,
                          precision: 2
                        }, null, 8 /* PROPS */, ["amount"]),
                        _createTextVNode(" / "),
                        _createVNode($setup["CoinAmount"], {
                          amount: campaign.amount,
                          "show-denom": true,
                          precision: 2
                        }, null, 8 /* PROPS */, ["amount"])
                      ])
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["header"]),
                  _createVNode($setup["ClaimInfo"], {
                    header: _ctx.$t('AIRDROP.MISSION_COMPLETED')
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", _hoisted_15, _toDisplayString($setup.getAmountOfClaimedMissions(campaign)) + "/" + _toDisplayString(campaign.missions.length), 1 /* TEXT */)
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["header"]),
                  _createVNode($setup["ClaimInfo"], {
                    header: $setup.getTextForTimeColumn(campaign)
                  }, {
                    default: _withCtx(() => [
                      ($setup.calculateTimeToPass(campaign))
                        ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString($setup.calculateTimeToPass(campaign)), 1 /* TEXT */))
                        : (_openBlock(), _createBlock($setup["DateCommon"], {
                            key: 1,
                            date: new Date(campaign.end_time),
                            "show-time": false,
                            "show-tooltip": true
                          }, null, 8 /* PROPS */, ["date"]))
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["header"]),
                  (!$setup.hideTotalDistribution(campaign))
                    ? (_openBlock(), _createBlock($setup["ClaimInfo"], {
                        key: 0,
                        header: _ctx.$t('AIRDROP.TOTAL_DISTRIBUTION')
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_17, [
                            _createVNode($setup["CoinAmount"], {
                              amount: campaign.totalDistribution,
                              "show-denom": true,
                              precision: 2
                            }, null, 8 /* PROPS */, ["amount"])
                          ])
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["header"]))
                    : _createCommentVNode("v-if", true)
                ]),
                _createElementVNode("div", _hoisted_18, [
                  (campaign.missions.length > 0)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: ($event: any) => ($setup.setActiveCampaign(campaign)),
                        class: "claimAirDrop__showBtn claimAirDrop__basicText"
                      }, [
                        ($setup.activeCampaign?.id !== campaign.id)
                          ? (_openBlock(), _createBlock($setup["ChevronDown"], {
                              key: 0,
                              size: 15
                            }))
                          : (_openBlock(), _createBlock($setup["ChevronUp"], {
                              key: 1,
                              size: 15
                            })),
                        _createElementVNode("p", null, _toDisplayString($setup.activeCampaign?.id === campaign.id ? _ctx.$t('AIRDROP.HIDE_MISSIONS') : _ctx.$t('AIRDROP.SHOW_MISSIONS')), 1 /* TEXT */)
                      ], 8 /* PROPS */, _hoisted_19))
                    : _createCommentVNode("v-if", true),
                  ($setup.activeCampaign?.id === campaign.id)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(campaign.missions, (missions, id) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "claimAirDrop__missions-body",
                            key: id
                          }, [
                            _createElementVNode("div", _hoisted_21, [
                              _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$t('AIRDROP.MISSION')) + " " + _toDisplayString(`#${missions.id}`), 1 /* TEXT */),
                              _createElementVNode("div", null, [
                                _createTextVNode(_toDisplayString(missions.description === 'Initial mission - basic mission that must be claimed first' ? _ctx.$t('AIRDROP.INITIAL') : missions.description) + " (" + _toDisplayString(missions.weightInPerc) + "%) - ", 1 /* TEXT */),
                                _createVNode($setup["CoinAmount"], {
                                  amount: missions.weight,
                                  "show-denom": true,
                                  precision: 2
                                }, null, 8 /* PROPS */, ["amount"])
                              ])
                            ]),
                            (!missions.claimed)
                              ? (_openBlock(), _createBlock(_component_Button, {
                                  key: 0,
                                  disabled: !$setup.isDisabled(campaign, missions),
                                  class: "p-button p-component secondary claimAirDrop__missions-btn",
                                  label: $setup.getTextForMissionsBtn(missions, missions.mission_type),
                                  onClick: ($event: any) => ($setup.redirectMission(campaign, missions, missions.mission_type))
                                }, null, 8 /* PROPS */, ["disabled", "label", "onClick"]))
                              : (_openBlock(), _createBlock(_component_Button, {
                                  key: 1,
                                  class: "p-button p-component secondary claimAirDrop__missions-shareBtn",
                                  label: "Share",
                                  onClick: _withModifiers(($event: any) => ($setup.onClickedShareButton(campaign, missions)), ["prevent"])
                                }, null, 8 /* PROPS */, ["onClick"]))
                          ]))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]))
                    : _createCommentVNode("v-if", true)
                ])
              ])
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("h4", null, _toDisplayString(_ctx.$t('AIRDROP.CONNECT_INFO')), 1 /* TEXT */),
                (!$setup.useUserStore().isLoggedIn)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 0,
                      class: "secondary h-3rem connectBtn",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.loginPopupStatus =! $setup.loginPopupStatus))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('COMMON.CONNECT')), 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    }))
                  : _createCommentVNode("v-if", true)
              ])
            ])
          ])
        ])),
    _createVNode($setup["Dialog"], {
      visible: $setup.sharePopupStatus,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => (($setup.sharePopupStatus) = $event)),
      modal: "",
      header: _ctx.$t('AIRDROP.SHARE_MESSAGE_HEADER'),
      style: { width: '50vw', 'min-width': '300px' }
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("h3", null, _toDisplayString(_ctx.$t('AIRDROP.SHARE_MESSAGE_BASE')), 1 /* TEXT */),
          _createElementVNode("p", null, _toDisplayString($setup.socialMediaMessage), 1 /* TEXT */),
          _createElementVNode("a", {
            href: `https://twitter.com/intent/tweet?text=${$setup.encodeUrlPart($setup.socialMediaMessage)}`,
            target: "_blank"
          }, [..._hoisted_30], 8 /* PROPS */, _hoisted_28)
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["visible", "header"])
  ], 64 /* STABLE_FRAGMENT */))
}